import actions from './actions'

const authOperations = {
  getUser: actions.getUser,
  updateUserWorkbookFilterList: actions.updateUserWorkbookFilterList,
}

export default authOperations
